import { getGraphqlBase } from "@/admin/graphql/getGraphqlBase.ts";
import { apiPrefixAtom } from "@/modules/api/createApiClient.ts";
import { atom } from "jotai/vanilla";

export const graphQlUriAtom = atom((get) => {
    const { host, protocol } = window.location;
    const apiPrefix = get(apiPrefixAtom);
    return `${protocol}//${getGraphqlBase(host, apiPrefix)}`;
});
